import React from "react";
import { useSelector } from "react-redux";
import { canManageFeatureToggles } from "../helper/permissions";
import Unauthorize from "./Unauthorize";

function FeatureToggleAdminGuard({ children }) {
  const login = useSelector((state) => state.root.login.loginDemo);

  return canManageFeatureToggles(login) ? children : <Unauthorize />;
}

export default FeatureToggleAdminGuard;
